import script from "./QuickStartClinicalReviewPage.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickStartClinicalReviewPage.vue?vue&type=script&setup=true&lang=js"

import "./QuickStartClinicalReviewPage.vue?vue&type=style&index=0&id=193aa228&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-193aa228"]])

export default __exports__